import React, { useState } from "react";
// import Openjobs from './openjobs'
// import Meetings from './meetings'
import Availability from "./Availability";
import Topbar from "../Recruiter/Topbar/Topbar";
import Button from "../elements/Button/Button";
import Meetings from "./meetings";
import Openjobs from "./openjobs";
import "./Calendly.css";
import { useLocation } from "react-router-dom";

const OpenJobsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {" "}
      <g clipPath="url(#clip0_489_191320)">
        {" "}
        <g clipPath="url(#clip1_489_191320)">
          {" "}
          <path
            d="M5 7V17C5 18.8856 5 19.8284 5.58579 20.4142C6.17157 21 7.11438 21 9 21H15C16.8856 21 17.8284 21 18.4142 20.4142C19 19.8284 19 18.8856 19 17V9.28145C19 8.40415 19 7.9655 18.827 7.57705C18.654 7.1886 18.328 6.89516 17.6759 6.30827L15.1409 4.02682C14.577 3.51929 14.295 3.26552 13.9491 3.13276C13.6031 3 13.2237 3 12.4651 3H9C7.11438 3 6.17157 3 5.58579 3.58579C5 4.17157 5 5.11438 5 7Z"
            stroke="#059669"
            strokeWidth="2"
          />{" "}
          <path
            d="M13 3V5C13 6.88562 13 7.82843 13.5858 8.41421C14.1716 9 15.1144 9 17 9H19"
            stroke="#059669"
            strokeWidth="2"
          />{" "}
        </g>{" "}
        <path
          d="M9 17.5H12M9 12.5H15M9 7.5H10"
          stroke="#059669"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />{" "}
      </g>{" "}
      <defs>
        {" "}
        <clipPath id="clip0_489_191320">
          {" "}
          <rect width="24" height="24" fill="white" />{" "}
        </clipPath>{" "}
        <clipPath id="clip1_489_191320">
          {" "}
          <rect width="24" height="24" fill="white" />{" "}
        </clipPath>{" "}
      </defs>{" "}
    </svg>
  );
};

const MeetingsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      className="mt-[1px]"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M17.1082 2.55302H9.35855L7.67968 0.55704C7.64097 0.511052 7.59267 0.474079 7.53818 0.448708C7.48368 0.423336 7.4243 0.410179 7.36419 0.410156H1.41207C1.35795 0.410142 1.30436 0.420791 1.25436 0.441495C1.20436 0.462198 1.15893 0.492551 1.12066 0.530818C1.08239 0.569085 1.05204 0.614517 1.03134 0.664519C1.01063 0.71452 0.999986 0.768111 1 0.822229V13.6955C1.00059 14.197 1.20008 14.6778 1.55473 15.0325C1.90937 15.3871 2.39021 15.5866 2.89175 15.5872H17.1082C17.6098 15.5866 18.0906 15.3871 18.4453 15.0325C18.7999 14.6778 18.9994 14.197 19 13.6955V4.44456C18.9994 3.94304 18.7999 3.46223 18.4452 3.10762C18.0906 2.75301 17.6098 2.55356 17.1082 2.55302ZM1.82414 1.2343H7.17223L8.28169 2.55302H1.82414V1.2343ZM18.1759 13.6955C18.1756 13.9785 18.063 14.2499 17.8628 14.45C17.6627 14.6502 17.3913 14.7628 17.1082 14.7631H2.89175C2.6087 14.7628 2.33732 14.6502 2.13717 14.45C1.93702 14.2499 1.82445 13.9785 1.82414 13.6955V3.37718H17.1082C17.3913 3.37747 17.6626 3.49001 17.8628 3.69012C18.0629 3.89022 18.1755 4.16154 18.1759 4.44456V13.6955Z"
        fill="#059669"
        stroke="#059669"
        strokeWidth="0.25"
      />
    </svg>
  );
};

const AvailabilityIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      className="mt-[1px]"
      fill="none"
    >
      <path
        d="M10.2453 16.2871H9.75358C9.17055 16.2863 8.69727 15.8138 8.69727 15.2308V12.5446C8.69727 11.9616 9.17057 11.4891 9.75358 11.4883H10.2453C10.8283 11.4891 11.3016 11.9616 11.3016 12.5446V15.2308C11.3016 15.8138 10.8283 16.2863 10.2453 16.2871ZM9.75358 12.0627C9.4869 12.0627 9.27146 12.2789 9.27066 12.5448V15.2309C9.27146 15.4968 9.4869 15.7131 9.75358 15.7131H10.2453C10.512 15.7131 10.7274 15.4968 10.7282 15.2309V12.5448C10.7274 12.2789 10.512 12.0627 10.2453 12.0627H9.75358Z"
        fill="#059669"
        stroke="#059669"
        strokeWidth="0.25"
      />
      <path
        d="M15.4866 7.9521C15.328 7.9521 15.1991 7.82397 15.1991 7.6654V5.76016C15.1991 4.22974 13.9538 2.98441 12.4234 2.98441H7.57651C6.04608 2.98441 4.80076 4.22974 4.80076 5.76016V7.6654C4.80076 7.82397 4.67182 7.9521 4.51326 7.9521C4.35469 7.9521 4.22656 7.82397 4.22656 7.6654V5.76016C4.22656 3.9126 5.72976 2.41016 7.57657 2.41016H12.4234C14.271 2.41016 15.7734 3.91335 15.7734 5.76016V7.6654C15.7734 7.74148 15.743 7.81436 15.6893 7.86802C15.6357 7.92168 15.5627 7.9521 15.4866 7.9521Z"
        fill="#059669"
        stroke="#059669"
        strokeWidth="0.25"
      />
      <path
        d="M13.7685 7.95049C13.61 7.95049 13.4818 7.82236 13.4818 7.66379V5.86988C13.481 5.1395 12.8884 4.54687 12.158 4.54607H7.84136C7.11098 4.54687 6.51836 5.1395 6.51756 5.86988V7.66379C6.51756 7.82236 6.38942 7.95049 6.23086 7.95049C6.07229 7.95049 5.94336 7.82236 5.94336 7.66379V5.86988C5.94496 4.82236 6.79386 3.97346 7.84138 3.97266H12.1581C13.2056 3.97346 14.0545 4.82236 14.0561 5.86988V7.66379C14.0561 7.82236 13.9271 7.95049 13.7685 7.95049Z"
        fill="#059669"
        stroke="#059669"
        strokeWidth="0.25"
      />
      <path
        d="M8.98443 13.9881C8.95961 13.9881 8.93478 13.9849 8.91075 13.9785L2.48239 12.2815C1.60866 12.0508 1 11.2604 1 10.357C1 10.1984 1.12814 10.0703 1.2867 10.0703C1.44526 10.0703 1.5734 10.1984 1.5734 10.357C1.5742 11.0001 2.00746 11.5623 2.62892 11.7265L9.05667 13.4235C9.19682 13.4603 9.28731 13.5949 9.2689 13.7382C9.25048 13.8808 9.12795 13.9881 8.9838 13.9881L8.98443 13.9881Z"
        fill="#059669"
        stroke="#059669"
        strokeWidth="0.25"
      />
      <path
        d="M11.0154 13.9881C10.8712 13.9881 10.7495 13.8808 10.7311 13.7382C10.7127 13.5949 10.8031 13.4603 10.9433 13.4235L17.3711 11.7265C17.9925 11.5623 18.4258 11.0001 18.4266 10.357C18.4266 10.1984 18.5547 10.0703 18.7133 10.0703C18.8718 10.0703 19 10.1984 19 10.357C19 11.2604 18.3913 12.0508 17.5176 12.2815L11.0892 13.9785C11.0652 13.9849 11.0402 13.9881 11.0154 13.9881Z"
        fill="#059669"
        stroke="#059669"
        strokeWidth="0.25"
      />
      <path
        d="M17.5128 19.149H2.48719C1.66631 19.1482 1.0008 18.4827 1 17.6618V8.86609C1.0008 8.04522 1.66631 7.37971 2.48719 7.37891H17.5128C18.3337 7.37971 18.9992 8.04522 19 8.86609V17.6618C18.9992 18.4827 18.3337 19.1482 17.5128 19.149ZM2.48719 7.95312C1.98266 7.95392 1.57422 8.36236 1.57342 8.86609V17.6618C1.57422 18.1655 1.98266 18.5748 2.48719 18.5748H17.5128C18.0173 18.5748 18.4258 18.1655 18.4266 17.6618V8.86609C18.4258 8.36236 18.0173 7.95392 17.5128 7.95312H2.48719Z"
        fill="#059669"
        stroke="#059669"
        strokeWidth="0.25"
      />
    </svg>
  );
};

const HamburgerIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12H21M3 6H21M3 18H21"
        stroke="#059669"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const CloseIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 6L6 18M6 6L18 18"
        stroke="#059669"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const CalendlyComponent = () => {
  const location = useLocation();
  const defaultPage = location.state?.defaultPage || "Open Jobs";
  const [sideChange, setSideChange] = useState(defaultPage);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const sideOptions = ["Open Jobs", "Meetings", "Availability"];

  const handleSideBar = (page) => {
    setSideChange(page);
    // Close sidebar on mobile after selection
    if (window.innerWidth < 1024) {
      setIsSidebarOpen(false);
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="radial-gradient-bg min-h-screen">
      <Topbar />

      {/* Mobile menu button */}
      <div className="lg:hidden px-4 py-2">
        <button
          onClick={toggleSidebar}
          className="flex items-center justify-center p-2 rounded-md bg-white shadow-md"
        >
          {isSidebarOpen ? <CloseIcon /> : <HamburgerIcon />}
        </button>
      </div>

      <div className="flex px-4 rounded-xl bg-opacity-50 relative">
        {/* Backdrop for mobile */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}

        {/* Sidebar */}
        <div
          className={`
            fixed lg:relative top-0 left-0 h-full lg:h-auto
            transform lg:transform-none transition-transform duration-300 ease-in-out
            ${
              isSidebarOpen
                ? "translate-x-0"
                : "-translate-x-full lg:translate-x-0"
            }
            bg-white lg:bg-transparent rounded-r-xl lg:rounded-none
            shadow-xl lg:shadow-none z-50 lg:z-auto
            w-64 lg:w-48 xl:w-52 py-5 px-4 lg:px-0
        `}
        >
          {/* Close button for mobile */}
          <div className="lg:hidden flex justify-end mb-4">
            <button
              onClick={() => setIsSidebarOpen(false)}
              className="p-2 rounded-md hover:bg-gray-100"
            >
              <CloseIcon />
            </button>
          </div>

          {/* Navigation buttons */}
          <div className="space-y-2 lg:space-y-0">
            {sideOptions.map((value, index) => (
              <Button
                key={index}
                id={index}
                className={`button-default w-full lg:w-auto text-left lg:text-center ${
                  sideChange === value ? "button-active" : ""
                }`}
                onClick={() => handleSideBar(value)}
              >
                <div className="flex items-center gap-3">
                  {value === "Open Jobs" && <OpenJobsIcon />}
                  {value === "Meetings" && <MeetingsIcon />}
                  {value === "Availability" && <AvailabilityIcon />}
                  <span className="lg:inline">{value}</span>
                </div>
              </Button>
            ))}
          </div>
        </div>

        {/* Main content */}
        <div className="w-full">
          {sideChange === "Open Jobs" && <Openjobs />}
          {sideChange === "Meetings" && <Meetings />}
          {sideChange === "Availability" && <Availability />}
        </div>
      </div>
    </div>
  );
};

export default CalendlyComponent;
